import { Constants } from '@applyonline/shared'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface Props {
  creditAppId: string
  useChangeLabel?: boolean
  merchantId?: string
  isHardDecline?: boolean
}

const ManageCoappButton = ({ creditAppId, useChangeLabel = false, merchantId, isHardDecline = false }: Props) => {
  const { t } = useTranslation()

  if (isHardDecline) {
    return null
  }

  // Hide button for specific merchant IDs
  if (merchantId && Constants.MerchantsThatForbidHavingCoapplicants.includes(merchantId)) {
    return null
  }

  return (
    <Link
      className="btn secondary-action-btn btn-simple"
      to={`/creditapplication/${creditAppId}/addcoapplicant/personal-information`}
    >
      {useChangeLabel ? t('common.changeCoapplicant') : t('common.addCoapplicant')}
    </Link>
  )
}

export default ManageCoappButton
